import {useQuery} from "@tanstack/react-query";
import {QUERY_KEYS} from "./queryKeys";
import Api from "../api/Api";

export const useMetadataQuery = (datasetId: string, enabled: boolean) => {
  return useQuery({
    queryKey: [QUERY_KEYS.dataset.metadata, datasetId],
    queryFn: async () => {
      if (!datasetId) return null
      return await Api.metadata.getMetadata(datasetId)
    },
    enabled: !!datasetId && enabled,
  })
}
